import React, { ReactNode } from 'react';
import ContentText from '@solid-ui-components/ContentText';
import { Flex, Box } from 'theme-ui';
import StyledButton from './StyledButton';
import { GatsbyImage as Img, getImage } from 'gatsby-plugin-image';
// import { css, jsx } from '@emotion/react'; // do not delete! it is in use!

const styles = {
  hoveredImageWrapper: {
    position: 'relative',
    minHeight: ['400px', '500px'],
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  hoveredImage: {
    py: [3, 3, 5],
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: '140%',
    maxWidth: ['90%', '90%', '80%'],
    height: '100%',
    ':hover': {
      '.hoveredImage': {
        transform: 'scale(1.1)',
      },
    },
    h1: {
      color: 'white',
      fontWeight: 700,
      fontSize: ['1.8em !important', '2em !important', '2.9em !important'],
      lineHeight: 1.1,
      margin: '.2em 0',
    },
    h4: {
      color: 'white',
      margin: '.6em 0',
      fontWeight: 300,
      fontSize: ['1em !important', '1.2em !important', '1.5em !important'],
    },
  },
  image: {
    zIndex: -2,
    transition: '.4s',
  },
  transparentBg: {
    zIndex: -1,
    backgroundColor: 'rgba(0,0,0,.6)',
  },
  absPos: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100% !important',
    height: '100% !important',
  },
  buttonWrapper: {
    fontWeight: 700,
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    h2: {
      color: '#ff0073',
      position: 'relative',
      fontSize: ['1.4rem !important', '1.4rem !important', '2rem !important'],
      '::after': {
        content: '""',
        color: 'green',
        position: 'absolute',
        left: 0,
        borderRadius: '999px',
        right: 0,
        top: '100%',
        height: '9px',
        imageRendering: '-webkit-optimize-contrast',
        backgroundSize: '100% 9px',
      },
    },
  },
  customComponentStyle: {
    zIndex: 1,
  },
};
const HoveredImage = ({
  style,
  image,
  header1,
  header2,
  header3,
  button,
  customComponent,
  eagerImage,
}: {
  style?: any;
  image: any;
  header1?: string;
  header2?: string;
  header3?: string;
  button?: { text: string; link?: string; icon?: any };
  customComponent?: ReactNode;
  eagerImage?: boolean;
}) => {
  return (
    <Flex sx={{ ...styles.hoveredImageWrapper, ...style }}>
      <Flex sx={{ ...styles.hoveredImage }}>
        {image && (
          <>
            <Img
              className='hoveredImage'
              image={getImage(
                image?.localFile_regular_mobile ||
                  image?.src?.ImageSharp_large_square
              )}
              alt={header1 || image.alt}
              loading={eagerImage ? 'eager' : 'lazy'}
              css={{ ...styles.image, ...image.style, ...styles.absPos }}
            />
          </>
        )}
        <div css={{ ...styles.absPos, ...styles.transparentBg }} />
        {header1 && <ContentText content={{ text: header1 }} variant='h1' />}
        {header2 && (
          <ContentText
            content={{
              text: header2,
            }}
            variant='h4'
          />
        )}
        <Box sx={styles.buttonWrapper}>
          {header3 && (
            <ContentText
              content={{
                text: header3,
              }}
              variant='h2'
            />
          )}
          {button && <StyledButton {...button} />}
        </Box>
        {customComponent && (
          <Box sx={styles.customComponentStyle}>{customComponent}</Box>
        )}
      </Flex>
    </Flex>
  );
};
export default HoveredImage;
